<template>
    <div
        v-if="promotion.type !== PROMO_TYPES.SALES_TARGET"
        class="mp-promos__data custom-grid tr-data is-column is-sm-row ow-cols-xl-6 row-cols-sm-2"
    >
        <div class="tr-data__cell">
            <div>
                <div>
                    <span class="tr-data__dt">ID</span>
                    <span class="tr-data__dd">{{ promotion.id }}</span>
                </div>
                <div class="d-none d-sm-flex">
                    <span class="tr-data__dt">Priorytet</span>
                    <span class="tr-data__dd">{{ promotion.priority }}</span>
                </div>
            </div>
            <div>
                <div>
                    <span class="tr-data__dt">{{ daysLeft.countText }}</span>
                    <span class="tr-data__dd">{{ daysLeft.diff }}</span>
                </div>
                <div>
                    <span class="tr-data__dt">Czas trwania promocji</span>
                    <span class="tr-data__dd">{{
                        durationDays | plurals('dzień', 'dni')
                    }}</span>
                </div>
            </div>
        </div>
        <div class="tr-data__cell">
            <div>
                <span class="tr-data__dt d-sm-none">{{
                    usageLimitPerReceiptLabelText
                }}</span>
                <span class="tr-data__dt d-sm-block d-none">{{
                    `Na paragon ${isWeight ? '(kg)' : ''}`
                }}</span>
                <span class="tr-data__dd">{{ usageLimitPerReceiptValue }}</span>
            </div>
            <div v-if="promotion.loyalty">
                <span class="tr-data__dt d-sm-none">
                    Limit użyć na kartę
                </span>
                <span class="tr-data__dt d-sm-block d-none">Na kartę</span>
                <span class="tr-data__dd">{{ usageLimitPerLoyaltyCard }}</span>
            </div>
            <div>
                <span class="tr-data__dt d-sm-none">Limit użyć na sklep</span>
                <span class="tr-data__dt d-sm-block d-none">Na sklep</span>
                <span class="tr-data__dd">{{ usageLimitPerLocation }}</span>
            </div>
            <div v-if="promotion.loyalty">
                <span class="tr-data__dt d-sm-none">Limit użyć na kartę (dzienny)</span>
                <span class="tr-data__dt d-sm-block d-none">Na kartę (dzienny)</span>
                <span class="tr-data__dd">{{
                    usageLimitPerLoyaltyCardDaily
                }}</span>
            </div>
        </div>
        <div class="tr-data__cell d-flex d-sm-none">
            <span class="tr-data__dt">Priorytet</span>
            <span @click.stop.prevent class="tr-data__dd">{{
                promotion.priority
            }}</span>
        </div>
    </div>
    <div
        v-else
        class="mp-promos__data tr-data is-column is-sm-row"
    >
        <div class="tr-data__cell">
            <div>
                <span class="tr-data__dt">ID</span>
                <span class="tr-data__dd">{{ promotion.id }}</span>
            </div>
        </div>
        <div class="tr-data__cell">
            <div>
                <span class="tr-data__dt">{{ daysLeft.countText }}</span>
                <span class="tr-data__dd">{{ daysLeft.diff }}</span>
            </div>
        </div>
        <div class="tr-data__cell">
            <div>
                <span class="tr-data__dt">Czas trwania promocji</span>
                <span class="tr-data__dd">
                    {{ durationDays | plurals('dzień', 'dni') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    props: {
        promotion: { type: Object, required: true }
    },
    created() {
        this.PROMO_TYPES = PROMO_TYPES
    },
    computed: {
        durationDays() {
            const start = moment(this.promotion.start_at).set({
                h: 0,
                m: 1,
                s: 0
            })
            const end = moment(this.promotion.end_at).set({
                h: 23,
                m: 59,
                s: 0
            })
            return Math.ceil(end.diff(start, 'days', true))
        },
        daysLeft() {
            return this.$store.getters.getDaysLeft(this.promotion)
        },
        usageLimitPerReceiptLabelText() {
            return this.isWeight
                ? 'Limit kg na paragon'
                : 'Limit użyć na paragonie'
        },
        usageLimitPerReceiptValue() {
            let usageLimitPerReceipt = this.promotion.usage_limit_per_receipt
            if (usageLimitPerReceipt) {
                usageLimitPerReceipt = Number(usageLimitPerReceipt)
                if (this.isWeight) {
                    usageLimitPerReceipt = usageLimitPerReceipt.toFixed(3)
                }
            }
            return usageLimitPerReceipt || '-'
        },
        usageLimitPerLocation() {
            return this.promotion.usage_limit_per_location || '-'
        },
        usageLimitPerLoyaltyCard() {
            return this.promotion.usage_limit_per_loyalty_card
                ? Number(this.promotion.usage_limit_per_loyalty_card)
                : '-'
        },
        usageLimitPerLoyaltyCardDaily() {
            return this.promotion.usage_limit_per_loyalty_card_daily
                ? Number(this.promotion.usage_limit_per_loyalty_card_daily)
                : '-'
        },
        isWeight() {
            return this.$store.getters.isWeight(this.promotion.type)
        }
    }
}
</script>
